<template>
  <div class="ingredients-input-wrapper">
      <div 
        class="ingredient-tag" 
        v-for="(item,index) in value" 
        :key="index"
        @click="onRemoveIngredient(index)">
          {{ item }}
      </div>
      <div class="ingredient-form">
          <textarea 
            type="text" 
            @keyup.enter="onAddNewIngredient" 
            class="ingredient-input" 
            rows="5"
            :placeholder="value.length ? $t('menu_settings.add_ingredients') : $t('menu_settings.input_ingredients')"
             maxlength="200" v-model="new_ingredient"></textarea>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            new_ingredient: null
        }
    },
    props: {
        value: Array
    },
    watch: {
        new_ingredient() {
            if (!this.new_ingredient) return;

            const comma_index = this.new_ingredient.indexOf(',');

            if (comma_index !== -1) {
                const to_add = this.new_ingredient
                    .split(',')
                    .map(s => s.trim())
                    .filter(s => s && s.length);

                this.$emit('input', this.value.concat(to_add));
                
                this.new_ingredient = null;
            }
        }
    },
    methods: {
        onAddNewIngredient() {
            if (!this.new_ingredient) return;

            const old_list = this.value.slice();

            old_list.push(this.new_ingredient);

            this.$emit('input', old_list);

            this.new_ingredient = null;
        },
        onRemoveIngredient(index) {
            const old_list = this.value.slice();

            old_list.splice(index, 1);

            this.$emit('input', old_list);
        }
    }
}
</script>

<style scoped>
.ingredients-input-wrapper {
    border-radius: 0.7vh;
    background: white;
    width: 100%;
    padding: 1.1vh;

    display: flex;
    flex-wrap: wrap;
}

.ingredient-tag {
    border-radius: 0.7vh;
    padding: 0.3vh 1vh;
    background: #129b81;
    color: #ededed;
    font-size: 1.7vh;

    display: flex;
    margin: 0.2vh;
    text-align: center;
}

.ingredient-tag:first-child {
    margin-left: 0;
}

.ingredient-tag:hover {
    background: #e2223b;
    cursor: pointer;
    color: #ededed;
}

.ingredient-input {
    border: none;
    outline: none;
    width: 100%;
    font-size: 1.6vh;
}

.ingredient-form {
    width: inherit;
    line-height: 1;
}
</style>